import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from "vuex-persist";
import Crypto from "crypto-js";
import MDownload50 from '@/store/modules/MDownload50.js';
import MDownload50Paotang from '@/store/modules/MDownload50Paotang.js';
import Block from '@/store/modules/BlockModule';
import Auth from '@/store/modules/auth.js';
import Certificate from '@/store/modules/certificate.js';
import CertificatePaotang from '@/store/modules/CertificatePaotang.js';
Vue.use(Vuex);

const storageKey = "registra";
const encryptionToken = "registra-6efea3e4-148e-4225-97b6-5da9af747dda";

const vuexSession = new VuexPersistence({
  storage: {
    getItem: () => {
      const store = window.localStorage.getItem(storageKey);

      if (store) {
        try {
          const bytes = Crypto.AES.decrypt(store, encryptionToken);

          return JSON.parse(bytes.toString(Crypto.enc.Utf8));
        } catch (e) {
          window.localStorage.removeItem(storageKey);
        }
      }

      return null;
    },
    setItem: (key, value) => {
      const store = Crypto.AES.encrypt(value, encryptionToken).toString();
      return window.localStorage.setItem(storageKey, store);
    },
    removeItem: () => window.localStorage.removeItem(storageKey),
  },
});

// Uncomment this code to unuse encryption
// const vuexSession = new VuexPersistence({
//   storage: {
//     getItem: () => window.localStorage.getItem(storageKey),
//     setItem: (key, value) => window.localStorage.setItem(storageKey, value),
//     removeItem: () => window.localStorage.removeItem(storageKey),
//   },
// });

export default new Vuex.Store({
  state: {
    stage: ''
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    MDownload50,
    MDownload50Paotang,
    Block,
    Auth,
    Certificate,
    CertificatePaotang
  },
  plugins: [vuexSession.plugin],
});
